<template>
	<div class="footer">
		<div class="centerWidth">
			<div class="f-info">
				<div>
					<div class="top-wrap">
						<div class="tit1">联系我们</div>
						<div class="tit2">联系电话：{{webconfig.phone}}</div>
					</div>
					<div class="f-info-center">
						<p><span>主办单位：{{webconfig.danwei}}</span></p>
						<p><span>地址：{{webconfig.address}}</span></p>
					</div>
				</div>
				<div class="qr-wrap">
					<img :src="domain + webconfig.wxcode" alt="">
					<span>扫码关注我们</span>
				</div>
			</div>
			<div class="banquan">
				版权所有 © {{webconfig.danwei}}  <a :href="copyright.value" target="_blank">{{copyright.key}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import config from "@/config"
	import {
		indexconfig
	} from "@/api/index";
	export default {
		name: "myFooter",
		data() {
			return {
				copyright: {},
				webconfig:{},
        domain:''
			}
		},
		mounted() {
			this.getInfo()
		},
		methods: {
			getInfo() {
				indexconfig().then(res => {
					if (res.code == 1) {
					  this.domain = res.data.domain
						this.copyright = res.data.copyright[0]
						this.webconfig = res.data.webconfig
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.footer {
		background: #1f58ae;
		padding-bottom: 30px;
		padding-top: 30px;
	}

	.top-wrap {
		.tit1 {
			color: #ffffff;
			font-size: 30px;
			font-family: fangsong;
			font-weight: bold;
			margin-bottom: 15px;
		}

		.tit2 {
			color: #ffffff;
			font-size: 16px;
			padding-bottom: 15px;
		}
	}

	.f-info {
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.f-info-center p {
		padding-bottom: 15px;
	}

	.f-info-center p {
		font-size: 16px;
		color: #fff;
	}

	.qr-wrap {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.qr-wrap img {
		width: 90px;
		height: 90px;
	}

	.qr-wrap span {
		font-size: 14px;
		margin-top: 5px;
	}

	.banquan,.banquan a {
		padding-top: 15px;
		border-top: 1px solid #fff;
		text-align: center;
		color: #fff;
		font-size: 14px;
	}
</style>
